import {
  autocompleteClasses,
  AutocompleteRenderInputParams,
  CircularProgress,
  inputBaseClasses,
  TextFieldProps
} from '@mui/material'
import TextField from '~/src/components/mui-wrappers/styled/text-field'
import FormikFieldPropsInterface from '~/src/types/FormikFieldProps'

type PickedAutocompleteProps = Omit<AutocompleteRenderInputParams, 'id' | 'name' | 'size' | 'inputProps' | 'fullWidth'>
type PickedTextFieldProps = FormikFieldPropsInterface & Omit<TextFieldProps, 'name' | 'size' | 'label' | 'autoComplete' | 'InputProps' | 'inputProps'>

type Props = PickedTextFieldProps & PickedAutocompleteProps & {
  isLoading?: boolean,
}

const FormikAddressRenderInput = ({
  isLoading,
  helperText,
  form,
  name,
  type = 'text',
  size,
  inputMode = 'text',
  required,
  sx = {},
  InputProps,
  ...otherProps
}: Props) => {
  return (
    <TextField
      id={name}
      name={name}
      error={form.touched[name] && !!form.errors[name]}
      helperText={form.touched[name] && !!form.errors[name] ? form.errors[name] as string : helperText}
      value={form.values[name]}
      variant='outlined'
      fullWidth
      onBlur={form.handleBlur}
      onChange={form.handleChange}
      aria-describedby={`${name}-helper-text`}
      size={size}
      required={required}
      sx={{
        [`.${inputBaseClasses.root}`]: {
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          [`.${autocompleteClasses.input}`]: {
            paddingTop: 1,
            paddingBottom: 1,
            paddingLeft: 1.75
          }
        },
        ...sx
      }}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {isLoading && (
              <CircularProgress
                disableShrink
                variant='indeterminate'
                size='1.25rem' />
            )}
            {InputProps.endAdornment}
          </>
        )
      }}
      {...otherProps}
      inputProps={{
        type: type,
        inputMode: inputMode,
        required: required,
        ...(otherProps as any)?.inputProps ?? {},
        autoComplete: 'new-address'
      }}
    />
  )
}

export default FormikAddressRenderInput
